// Rastreo de vistas de página en la SPA. react-router no recarga la página al
// navegar, así que GA4/Hotjar no verían los cambios de ruta por sí solos: este
// hook emite un page_view en cada cambio de pathname+search.
//
// Debe montarse DENTRO del <BrowserRouter> (usa useLocation).

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from './analytics.js';

/** Emite un page_view por cada cambio de ruta (pathname + querystring). */
export function usePageTracking(): void {
  const location = useLocation();
  useEffect(() => {
    const path = location.pathname + location.search;
    trackPageView(path);
  }, [location.pathname, location.search]);
}
